import type { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { Box, Flex, desktopFirstMediaQuery } from '@inflearn/ds-react';
import type { ParseKeys } from 'i18next';
import { isNil } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import type { ReactNode } from 'react';

import AppShellLayoutForCSR from '../AppShellLayoutForCSR';
import type { CustomHeadProps } from '../CustomHead';
import CustomHead from '../CustomHead';
import { DefaultGuard } from '../DefaultLayout';

interface PartnersLayoutProps {
  children: ReactNode;
  meta?: CustomHeadProps & {
    title: ParseKeys;
    description?: ParseKeys;
    pageCategory?: ParseKeys;
  };
  guard?: ({ children }: { children: ReactNode }) => EmotionJSX.Element;
}

export const PartnersLayout = ({
  guard: Guard = DefaultGuard,
  children,
  meta,
}: PartnersLayoutProps) => {
  const { t } = useTranslation();

  return (
    <>
      {!isNil(meta) && (
        <CustomHead
          {...meta}
          title={t(meta.title)}
          siteTitle={t('인프런')}
          description={meta.description ? t(meta.description) : undefined}
          pageCategory={t(
            meta.pageCategory ? meta.pageCategory : t('메타.마이페이지.페이지카테고리'),
          )}
        />
      )}
      <AppShellLayoutForCSR
        requiredLogin
        showChanneltalk={false}
        hasFNB={false}
        showLanguageSectionButton={true}
      >
        <Guard>
          <Box component="main" mih="100vh" mx="auto">
            <Flex
              direction="column"
              w="100%"
              mx="auto"
              maw={700}
              css={{
                paddingInline: 32,
                paddingTop: 32,
                paddingBottom: 80,

                [desktopFirstMediaQuery.tablet]: {
                  paddingInline: 32,
                  paddingTop: 32,
                  paddingBottom: 40,
                },

                [desktopFirstMediaQuery.mobile]: {
                  padding: `24px 16px`,
                },
              }}
            >
              {children}
            </Flex>
          </Box>
        </Guard>
      </AppShellLayoutForCSR>
    </>
  );
};
